import { detectWeChatMiniProgram } from './useWeChatSDK.js'

export async function getAppName() {
  const params = new URLSearchParams(window.location.search)
  const isWechatMiniProgram = await detectWeChatMiniProgram()
  if (isWechatMiniProgram) {
    return 'wechat-mp-photo-auth'
  }

  // keep old `is_wechat` behavior for backward compatibility
  if (params.get('is_wechat')) {
    return 'photo-auth-mp'
  }

  const appName = params.get('app_name')
  if (appName) {
    return appName
  }
  // return default app name.
  return 'photo-auth'
}
